import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'frodo-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: SelectComponent, multi: true }],
})
export class SelectComponent implements ControlValueAccessor {
  @Input() disabled = false;
  @Output() selectionChange = new EventEmitter<string>();

  @ViewChild('panel', { static: true }) panelEl!: ElementRef<HTMLElement>;

  open = false;
  value = '';

  constructor(private hostEl: ElementRef<HTMLElement>) {}

  writeValue(value: string | null | undefined): void {
    this.value = value ?? '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
  registerOnTouched(fn: VoidFunction): void {}

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  @HostListener('document:pointerdown', ['$event'])
  onPointerDownOutside(event: PointerEvent): void {
    if (!this.open) return;

    const target = event.target as Node;
    if (!target) return;

    if (this.hostEl.nativeElement.contains(target)) return;

    this.closePanel();
  }

  onClick(): void {
    if (this.disabled) return;

    this.open = !this.open;

    if (this.open) {
      this.scrollToSelectedValue();
    }
  }

  closePanel(): void {
    this.open = false;
  }

  isValueSelected(v: string): boolean {
    return v === this.value;
  }

  selectValueFromOption(value: string): void {
    this.value = value;
    this.onChange(value);
    this.selectionChange.emit(value);
    this.closePanel();
  }

  private onChange(value: string): void {
    this.value = value;
  }

  private scrollToSelectedValue(): void {
    requestAnimationFrame(() => {
      const panel = this.panelEl.nativeElement;
      if (!panel) return;

      const selected = panel.querySelector<HTMLElement>('frodo-select-option.is-selected');
      if (!selected) return;

      const target = selected.offsetTop - panel.clientHeight / 2 + selected.offsetHeight / 2;

      const max = panel.scrollHeight - panel.clientHeight;
      panel.scrollTop = Math.max(0, Math.min(target, max));
    });
  }
}
